import React from 'react';
import smallAreas from '../../helpers/small-areas';
import styles from './small-area.module.scss';

export default function SmallAreaList({ onClick }) {
  const baseUrl = process.env.PUBLIC_URL || '';
  return (
    <div>
      {smallAreas.map(({ name, icon }) => {
        return (
          <li
            key={name}
            role="button"
            onClick={onClick({ id: name })}
            className={styles.li}
          >
            <img src={baseUrl + icon} alt={name} />{' '}
            <span className={styles.name}>{name}</span>
          </li>
        );
      })}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/small-area-list/small-area-list.js